import { render, staticRenderFns } from "./AssetDetail.vue?vue&type=template&id=49c7e3fb&scoped=true"
import script from "./AssetDetail.vue?vue&type=script&lang=js"
export * from "./AssetDetail.vue?vue&type=script&lang=js"
import style0 from "./AssetDetail.vue?vue&type=style&index=0&id=49c7e3fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c7e3fb",
  null
  
)

export default component.exports